import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class IpService {
    constructor(private httpClient: HttpClient) {
    }

    getIp() {
        return this.httpClient.get('https://api.ipify.org/?format=json');
    }
}